import type { ActiveIdp, OrgInfo, OrgLookupResult } from "shell/api/types";

import {
  IdpStatus,
  type OrganisationEmailDomainIdp,
} from "generated/api/organisations/models";
import { getOrganisationByEmailDomain } from "generated/api/organisations/organisations/organisations";

const extractDomain = (email: string): string | undefined => {
  return email.split("@")[1]?.toLowerCase();
};

export const parseIdpConfigs = (
  configs: OrganisationEmailDomainIdp[],
): ActiveIdp[] => {
  const seen = new Set<string>();
  const result: ActiveIdp[] = [];

  for (const idp of configs) {
    if (
      idp.status === IdpStatus.ACTIVE &&
      idp.cognito_provider_name &&
      !seen.has(idp.cognito_provider_name)
    ) {
      seen.add(idp.cognito_provider_name);
      result.push({
        cognitoProviderName: idp.cognito_provider_name,
        name: idp.name,
        type: idp.idp_type,
      });
    }
  }

  return result;
};

const fetchDomainOrgs = async (domain: string): Promise<OrgInfo[] | null> => {
  const response = await getOrganisationByEmailDomain(domain);
  if (response.status !== 200) return null;
  return response.data.organisations;
};

export const lookupEmailOrgs = async (
  email: string,
): Promise<OrgLookupResult> => {
  const domain = extractDomain(email);
  if (!domain) {
    return { ok: false, error: "invalidEmail" };
  }
  try {
    const orgs = await fetchDomainOrgs(domain);
    if (!orgs) {
      return { ok: false, error: "lookupFailed" };
    }
    return { ok: true, orgs };
  } catch {
    return { ok: false, error: "lookupFailed" };
  }
};
